<div class="financeiro-page">
  <header class="financeiro-header">
    <div class="financeiro-header__content">
      <div class="financeiro-header__icon">
        <mat-icon fontSet="material-symbols-outlined">monetization_on</mat-icon>
      </div>
      <div>
        <h1>Financeiro</h1>
        <p>Acompanhe as mensalidades, matrículas e materiais didáticos</p>
      </div>
    </div>
  </header>

  <main class="financeiro-content">
    <section class="controls-section" aria-label="Filtros financeiros">
      <div class="aluno-selector-container">
        <div class="alunos-list">
          <button
            type="button"
            class="aluno-option"
            [class.active]="todasParcelasSelecionado"
            (click)="selecionarTodasParcelas()">
            <span class="aluno-option__icon">
              <mat-icon fontSet="material-symbols-outlined">payments</mat-icon>
            </span>
            <span class="aluno-option__content">
              <strong>Todas as parcelas financeiras</strong>
            </span>
          </button>

          <button
            type="button"
            *ngFor="let aluno of alunos"
            class="aluno-option"
            [class.active]="!todasParcelasSelecionado && alunoSelecionado?.id === aluno.id"
            (click)="selecionarAluno(aluno)">
            <span class="aluno-option__icon">
              <mat-icon>person</mat-icon>
            </span>
            <span class="aluno-option__content">
              <strong>{{ aluno.nome }}</strong>
              <small>{{ aluno.serie }}</small>
            </span>
          </button>
        </div>
      </div>

      <div class="ano-selector">
        <label for="ano-select">Ano letivo:</label>
        <select id="ano-select" [(ngModel)]="anoSelecionado" (ngModelChange)="onAnoChange()">
          <option *ngFor="let ano of anosLetivos" [ngValue]="ano">
            {{ getDescricaoAnoTurma(ano) }}
          </option>
        </select>
      </div>
    </section>

    <section class="aluno-context" *ngIf="alunoSelecionado || todasParcelasSelecionado">
      <span class="aluno-context__icon">
        <mat-icon>{{ todasParcelasSelecionado ? 'payments' : 'person' }}</mat-icon>
      </span>
      <div>
        <h2>{{ todasParcelasSelecionado ? 'Todas as parcelas financeiras' : alunoSelecionado?.nome }}</h2>
        <p>{{ getDescricaoSelecionada() }}</p>
      </div>
    </section>

    <div class="loading-state" *ngIf="carregandoFinanceiro">
      <div class="loading-spinner"></div>
      <p>Carregando dados financeiros...</p>
    </div>

    <section class="resumo-grid" *ngIf="resumo && !carregandoFinanceiro" aria-label="Resumo financeiro">
      <article class="resumo-card resumo-card--primary">
        <div>
          <span class="resumo-card__label">Total a pagar</span>
          <strong>{{ resumo.totalAPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>
        </div>
      </article>

      <article class="resumo-card resumo-card--success">
        <div>
          <span class="resumo-card__label">Total pago</span>
          <strong>{{ resumo.totalPago | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>
        </div>
      </article>

      <article class="resumo-card resumo-card--warning">
        <div>
          <span class="resumo-card__label">Saldo em aberto</span>
          <strong>{{ resumo.saldoEmAberto | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>
        </div>
      </article>

      <article class="resumo-card resumo-card--danger">
        <div>
          <span class="resumo-card__label">Saldo atrasado</span>
          <strong>{{ resumo.saldoAtrasado | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong>
        </div>
      </article>
    </section>

    <section class="contas-area" *ngIf="contas.length > 0 && !carregandoFinanceiro">
      <div class="contas-toolbar">
        <button
          type="button"
          class="btn contas-toolbar__primary"
          [disabled]="contasSelecionadas.size === 0">
          <mat-icon fontSet="material-symbols-outlined">credit_card</mat-icon>
          Pagar selecionadas
        </button>
        <button type="button" class="btn contas-toolbar__secondary">
          <mat-icon fontSet="material-symbols-outlined">request_quote</mat-icon>
          Doc. de quitação de débitos
        </button>
      </div>

      <div class="contas-section">
        <div class="table-responsive">
        <table class="table contas-table align-middle mb-0" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th class="selection-column">
                <input
                  type="checkbox"
                  class="form-check-input"
                  aria-label="Selecionar todas as parcelas"
                  [checked]="todasContasSelecionadas"
                  (change)="alternarTodasContas($any($event.target).checked)">
              </th>
              <th class="documents-column"></th>
              <th>Status</th>
              <th>Descrição</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Valor pago</th>
              <th>Data pagamento</th>
              <th class="actions-column">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let conta of contas">
              <td class="selection-column">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [attr.aria-label]="'Selecionar ' + conta.descricao"
                  [checked]="contasSelecionadas.has(conta.contaParcelaId)"
                  (change)="alternarConta(conta.contaParcelaId, $any($event.target).checked)">
              </td>
              <td class="documents-column">
                <div class="documentos-cell">
                  <button
                    type="button"
                    class="documento-action"
                    [ngClass]="getClasseBoleto(conta)"
                    [title]="getTituloBoleto(conta)"
                    [disabled]="!boletoDisponivel(conta)"
                    aria-label="Abrir boleto"
                    (click)="abrirBoleto(conta)">
                    <mat-icon fontSet="material-symbols-outlined">barcode_scanner</mat-icon>
                  </button>

                  <button
                    type="button"
                    *ngIf="exibirIconeNotaFiscal(conta)"
                    class="documento-action text-success"
                    title="Abrir nota fiscal"
                    aria-label="Abrir nota fiscal"
                    (click)="abrirNotaFiscal(conta.linkNotaFiscalPrefeitura)">
                    <mat-icon fontSet="material-symbols-outlined">receipt_long</mat-icon>
                  </button>
                </div>
              </td>
              <td>
                <span class="status-pill" [ngClass]="getClasseStatus(conta)">
                  {{ getTextoStatusPagamento(conta) | uppercase }}
                </span>
              </td>
              <td class="description-column">
                <strong>{{ conta.descricao }}</strong>
                <small>{{ conta.nomeResponsavelFinanceiro }}</small>
              </td>
              <td class="text-nowrap">{{ conta.dataVencimento | date:'dd/MM/yyyy':'':'pt-BR' }}</td>
              <td class="text-nowrap">
                {{ conta.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
              </td>
              <td class="text-nowrap">
                {{ conta.valorPago | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
              </td>
              <td class="text-nowrap">
                {{ conta.dataPagamento ? (conta.dataPagamento | date:'dd/MM/yyyy':'':'pt-BR') : 'Pendente' }}
              </td>
              <td class="actions-column">
                <button
                  type="button"
                  class="btn pagar-button"
                  [disabled]="isContaQuitada(conta.statusPagamento)"
                  (click)="selecionarParaPagamento(conta.contaParcelaId)">
                  <mat-icon fontSet="material-symbols-outlined">credit_card</mat-icon>
                  Pagar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="contas-mobile-list" aria-label="Contas a receber">
          <label class="contas-mobile-select-all">
            <input
              type="checkbox"
              class="form-check-input"
              aria-label="Selecionar todas as parcelas"
              [checked]="todasContasSelecionadas"
              (change)="alternarTodasContas($any($event.target).checked)">
            <span>Selecionar todas</span>
          </label>

          <article class="conta-mobile-card" *ngFor="let conta of contas">
            <div class="conta-mobile-card__header">
              <label class="conta-mobile-card__select">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [attr.aria-label]="'Selecionar ' + conta.descricao"
                  [checked]="contasSelecionadas.has(conta.contaParcelaId)"
                  (change)="alternarConta(conta.contaParcelaId, $any($event.target).checked)">
              </label>

              <span class="status-pill" [ngClass]="getClasseStatus(conta)">
                {{ getTextoStatusPagamento(conta) | uppercase }}
              </span>
            </div>

            <div class="conta-mobile-card__body">
              <div class="conta-mobile-card__description">
                <strong>{{ conta.descricao }}</strong>
                <small>{{ conta.nomeResponsavelFinanceiro }}</small>
              </div>

              <dl class="conta-mobile-card__details">
                <div>
                  <dt>Vencimento</dt>
                  <dd>{{ conta.dataVencimento | date:'dd/MM/yyyy':'':'pt-BR' }}</dd>
                </div>
                <div>
                  <dt>Valor</dt>
                  <dd>{{ conta.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</dd>
                </div>
                <div>
                  <dt>Valor pago</dt>
                  <dd>{{ conta.valorPago | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</dd>
                </div>
                <div>
                  <dt>Pagamento</dt>
                  <dd>{{ conta.dataPagamento ? (conta.dataPagamento | date:'dd/MM/yyyy':'':'pt-BR') : 'Pendente' }}</dd>
                </div>
              </dl>
            </div>

            <div class="conta-mobile-card__footer">
              <div class="documentos-cell">
                <button
                  type="button"
                  class="documento-action"
                  [ngClass]="getClasseBoleto(conta)"
                  [title]="getTituloBoleto(conta)"
                  [disabled]="!boletoDisponivel(conta)"
                  aria-label="Abrir boleto"
                  (click)="abrirBoleto(conta)">
                  <mat-icon fontSet="material-symbols-outlined">barcode_scanner</mat-icon>
                </button>

                <button
                  type="button"
                  *ngIf="exibirIconeNotaFiscal(conta)"
                  class="documento-action text-success"
                  title="Abrir nota fiscal"
                  aria-label="Abrir nota fiscal"
                  (click)="abrirNotaFiscal(conta.linkNotaFiscalPrefeitura)">
                  <mat-icon fontSet="material-symbols-outlined">receipt_long</mat-icon>
                </button>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="financeiro-empty-state" *ngIf="!carregandoFinanceiro && !erroFinanceiro && resumo && contas.length === 0">
      <span class="empty-icon">
        <mat-icon fontSet="material-symbols-outlined">inbox</mat-icon>
      </span>
      <h2>Nenhuma cobrança encontrada</h2>
      <p>Não há contas a receber para este período.</p>
    </section>

    <section class="financeiro-empty-state financeiro-empty-state--error" *ngIf="!carregandoFinanceiro && erroFinanceiro">
      <span class="empty-icon">
        <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
      </span>
      <h2>Erro ao carregar</h2>
      <p>Não foi possível carregar os dados financeiros. Tente novamente.</p>
    </section>

    <section class="financeiro-empty-state" *ngIf="!carregandoFinanceiro && !erroFinanceiro && !resumo && anosLetivos.length === 0 && !alunoSelecionado">
      <span class="empty-icon">
        <mat-icon fontSet="material-symbols-outlined">person_search</mat-icon>
      </span>
      <h2>Selecione um aluno</h2>
      <p>Escolha um aluno acima para visualizar o financeiro.</p>
    </section>
  </main>
</div>